<div
  [ngClass]="{
    'order-entry__panel-more__private-order__container': true,
    'order-entry__panel-more__private-order__container--checked': data.value && !data.locked,
    'order-entry__panel-more__private-order__container--unchecked': !data.value && !data.locked,
    'order-entry__panel-more__private-order__container--locked': data.locked
  }"
>
  <p-checkbox
    class="order-entry__panel-more__private-order__checkbox"
    [binary]="true"
    [disabled]="data.locked"
    [label]="data.label"
    [(ngModel)]="data.value"
    (ngModelChange)="onValueChange()"
  >
  </p-checkbox>
</div>
